import React from 'react';
import { get, debounce } from 'lodash';
import RenderDatepickerFilter from '../Form/RenderDatePickerFilter';
import OnTextOrDateFilter from '../Form/OnTextOrDateFilter';
import TextField from '../TextField/TextField';

export const onTextFilter = (props) => {
  const { filter, onChange, ...rest } = props;
  const filterVal = get(filter, 'value', '');
  const key = !filterVal ? 'empty-key' : get(filter, 'id', 'default-key');

  return <TextField key={key} defaultValue={filterVal} onChange={(e) => onChange(e.target.value)} fullWidth {...rest} />;
};

export const handleTextFilter = (inputProps) => (filterProps) => onTextFilter({ ...filterProps, ...inputProps });
export const makeDebounceOnTextFilter =
  (howLong = 1000, inputProps) =>
  ({ filter, onChange }) =>
    onTextFilter({ filter, onChange: debounce(onChange, howLong), ...inputProps });
export const onTextFilterNosaving = ({ onChange }) => {
  const forwardChange = debounce(onChange, 500);

  return <TextField onChange={(e) => forwardChange(e.target.value)} fullWidth />;
};
export const onTextOrDatePickerFilter = ({ filter, onChange, isModal }) => (
  <OnTextOrDateFilter filter={filter} onChange={onChange} isModal={isModal} />
);
export const onDatePickerFilter = ({ filter, onChange }) => (
  <RenderDatepickerFilter onChange={onChange} value={filter ? filter.value : ''} />
);
export const onDatePickerFilterTimeStampOutput = ({ filter, onChange }) => (
  <RenderDatepickerFilter onChange={onChange} timestampOutput value={filter ? filter.value : ''} />
);
